import Helper from "./Helper";
import Swiper from "../lib/swiper";
import swiper from "../lib/swiper";

class Slider {
  constructor(config = {}) {
    const {} = config;

    this.sliders = document.querySelectorAll('.ns-img-slider');
    this.swiperInstance = null;
    this.initSwiper(config);
  }

  initSwiper(config) {
    this.swiperInstance = new Swiper('.ns-img-slider', {
      loop: true,
      slidesPerView: 1,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    this.scrollToActiveSlide(document.querySelector('.ns-img-slider'));
  }

  scrollToActiveSlide(sliderDOMRef) {
    if (this.swiperInstance && sliderDOMRef) {
      let slides = sliderDOMRef.querySelectorAll('.swiper-slide');
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('swiper-slide--active')) {
          this.swiperInstance.slideTo(i, false, false);
          return;
        }
      }
    }
  }
}

export default Slider;
